import {setFetchingForView, setMetaProp, setView, setCurrent, remove} from '../../../helpers'

export default {
  setFetchingForView,
  setCurrent,
  setMetaProp,
  setView,
  remove
}



// WEBPACK FOOTER //
// ./src/store/modules/media/mutations.js